import { render, staticRenderFns } from "./costPerPiece.vue?vue&type=template&id=0b889f74"
import script from "./costPerPiece.vue?vue&type=script&lang=js"
export * from "./costPerPiece.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports